import { useState, useEffect, useContext } from "react";
import { AppConfigContext } from "../context";
import { KyrosToken } from "../rest/kairos/types";

export const useKyrosTokens = () => {
    const { apiUrl } = useContext(AppConfigContext);
    const [tokens, setTokens] = useState<KyrosToken[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchTokens = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(`${apiUrl}/kyros/tokens`);
            const data = await response.json();

            if (Array.isArray(data)) {
                setTokens(
                    data
                        .filter((token): token is KyrosToken => (
                            !!token &&
                            typeof token.id === "string" &&
                            typeof token.name === "string" &&
                            typeof token.symbol === "string" &&
                            typeof token.icon === "string" &&
                            (typeof token.mcap === "number" || typeof token.mcap === "undefined")
                        ))
                );
            } else {
                setTokens([]);
            }
        } catch (err) {
            console.error("Error fetching tokens:", err);
            setTokens([]);
            setError("Error fetching tokens");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTokens();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { tokens, isLoading, error, refetch: fetchTokens };
};
